import { __decorate, __param } from 'tslib';
import { ViewChildren, forwardRef, Input, Directive, Inject, Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { tuiDefaultProp as tuiDefaultProp$1 } from '@taiga-ui/cdk/decorators';
import { TUI_DATA_LIST_ACCESSOR } from '@taiga-ui/core/tokens';
import { TUI_ITEMS_HANDLERS } from '@taiga-ui/kit/tokens';
import { EMPTY_QUERY, isNativeFocused, isPresent, tuiDefaultProp, TuiElementModule } from '@taiga-ui/cdk';
import { TuiOptionComponent, TUI_DATA_LIST_ACCESSOR as TUI_DATA_LIST_ACCESSOR$1, TuiDataListModule, TuiLoaderModule, TuiDataListDirective } from '@taiga-ui/core';
import { CommonModule } from '@angular/common';
import { PolymorpheusModule } from '@tinkoff/ng-polymorpheus';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@taiga-ui/core';
import * as ɵngcc3 from '@taiga-ui/cdk';
import * as ɵngcc4 from '@tinkoff/ng-polymorpheus';

const _c0 = ["labels", ""];
function TuiDataListGroupWrapperComponent_tui_data_list_0_tui_opt_group_1_button_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 6, 7);
    ɵngcc0.ɵɵelement(2, "span", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r7 = ctx.$implicit;
    const _r8 = ɵngcc0.ɵɵreference(1);
    const ctx_r6 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("size", ctx_r6.size)("value", item_r7)("disabled", ctx_r6.disabledItemHandler(item_r7));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("content", ctx_r6.itemContent)("context", ctx_r6.getContext(item_r7, _r8));
} }
function TuiDataListGroupWrapperComponent_tui_data_list_0_tui_opt_group_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tui-opt-group", 4);
    ɵngcc0.ɵɵtemplate(1, TuiDataListGroupWrapperComponent_tui_data_list_0_tui_opt_group_1_button_1_Template, 3, 5, "button", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const group_r4 = ctx.$implicit;
    const index_r5 = ctx.index;
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("label", ctx_r3.labels[index_r5]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", group_r4);
} }
function TuiDataListGroupWrapperComponent_tui_data_list_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tui-data-list", 2);
    ɵngcc0.ɵɵtemplate(1, TuiDataListGroupWrapperComponent_tui_data_list_0_tui_opt_group_1_Template, 2, 2, "tui-opt-group", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("emptyContent", ctx_r0.emptyContent);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.items);
} }
function TuiDataListGroupWrapperComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "tui-loader", 9);
} }
function TuiDataListWrapperComponent_tui_data_list_0_button_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 4, 5);
    ɵngcc0.ɵɵelement(2, "span", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    const _r5 = ɵngcc0.ɵɵreference(1);
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("size", ctx_r3.size)("value", item_r4)("disabled", ctx_r3.disabledItemHandler(item_r4));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("content", ctx_r3.itemContent)("context", ctx_r3.getContext(item_r4, _r5));
} }
function TuiDataListWrapperComponent_tui_data_list_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tui-data-list", 2);
    ɵngcc0.ɵɵtemplate(1, TuiDataListWrapperComponent_tui_data_list_0_button_1_Template, 3, 5, "button", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("emptyContent", ctx_r0.emptyContent);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.items);
} }
function TuiDataListWrapperComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "tui-loader", 7);
} }
const _c1 = "[_nghost-%COMP%]{display:block}.t-content[_ngcontent-%COMP%]{flex:1}.t-loader[_ngcontent-%COMP%]{margin:.75rem 0}";
let AbstractDataListWrapper = class AbstractDataListWrapper {
    constructor(itemsHandlers) {
        this.itemsHandlers = itemsHandlers;
        this.optionsQuery = EMPTY_QUERY;
        this.disabledItemHandler = this.itemsHandlers.disabledItemHandler;
        this.emptyContent = '';
        this.size = 'm';
        this.itemContent = ({ $implicit }) => this.itemsHandlers.stringify($implicit);
    }
    getContext($implicit, { nativeElement }) {
        return { $implicit, active: isNativeFocused(nativeElement) };
    }
    getOptions(includeDisabled = false) {
        return this.optionsQuery
            .toArray()
            .filter(({ disabled }) => includeDisabled || !disabled)
            .map(({ value }) => value)
            .filter(isPresent);
    }
};
AbstractDataListWrapper.ɵfac = function AbstractDataListWrapper_Factory(t) { return new (t || AbstractDataListWrapper)(ɵngcc0.ɵɵdirectiveInject(undefined)); };
AbstractDataListWrapper.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: AbstractDataListWrapper, viewQuery: function AbstractDataListWrapper_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(TuiOptionComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.optionsQuery = _t);
    } }, inputs: { disabledItemHandler: "disabledItemHandler", emptyContent: "emptyContent", size: "size", itemContent: "itemContent" } });
AbstractDataListWrapper.ctorParameters = () => [
    { type: undefined }
];
__decorate([
    ViewChildren(forwardRef(() => TuiOptionComponent))
], AbstractDataListWrapper.prototype, "optionsQuery", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], AbstractDataListWrapper.prototype, "disabledItemHandler", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], AbstractDataListWrapper.prototype, "emptyContent", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], AbstractDataListWrapper.prototype, "size", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], AbstractDataListWrapper.prototype, "itemContent", void 0);

var TuiDataListGroupWrapperComponent_1;
let TuiDataListGroupWrapperComponent = TuiDataListGroupWrapperComponent_1 = class TuiDataListGroupWrapperComponent extends AbstractDataListWrapper {
    constructor(itemsHandlers) {
        super(itemsHandlers);
        this.items = [];
        this.labels = [];
    }
};
TuiDataListGroupWrapperComponent.ɵfac = function TuiDataListGroupWrapperComponent_Factory(t) { return new (t || TuiDataListGroupWrapperComponent)(ɵngcc0.ɵɵdirectiveInject(TUI_ITEMS_HANDLERS)); };
TuiDataListGroupWrapperComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TuiDataListGroupWrapperComponent, selectors: [["tui-data-list-wrapper", "labels", ""]], inputs: { items: "items", labels: "labels" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TUI_DATA_LIST_ACCESSOR,
                useExisting: forwardRef(() => TuiDataListGroupWrapperComponent_1)
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], attrs: _c0, decls: 3, vars: 2, consts: [[3, "emptyContent", 4, "ngIf", "ngIfElse"], ["loading", ""], [3, "emptyContent"], [3, "label", 4, "ngFor", "ngForOf"], [3, "label"], ["tuiElement", "", "tuiOption", "", "automation-id", "tui-data-list-wrapper__option", 3, "size", "value", "disabled", 4, "ngFor", "ngForOf"], ["tuiElement", "", "tuiOption", "", "automation-id", "tui-data-list-wrapper__option", 3, "size", "value", "disabled"], ["elementRef", "elementRef"], ["polymorpheus-outlet", "", 1, "t-content", 3, "content", "context"], [1, "t-loader"]], template: function TuiDataListGroupWrapperComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TuiDataListGroupWrapperComponent_tui_data_list_0_Template, 2, 2, "tui-data-list", 0);
        ɵngcc0.ɵɵtemplate(1, TuiDataListGroupWrapperComponent_ng_template_1_Template, 1, 0, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.items)("ngIfElse", _r1);
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.TuiDataListComponent, ɵngcc1.NgForOf, ɵngcc2.TuiOptGroupDirective, ɵngcc2.TuiOptionComponent, ɵngcc3.TuiElementDirective, ɵngcc4.PolymorpheusOutletComponent, ɵngcc2.TuiLoaderComponent], styles: [_c1], changeDetection: 0 });
TuiDataListGroupWrapperComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [TUI_ITEMS_HANDLERS,] }] }
];
__decorate([
    Input(),
    tuiDefaultProp$1()
], TuiDataListGroupWrapperComponent.prototype, "items", void 0);
__decorate([
    Input(),
    tuiDefaultProp$1()
], TuiDataListGroupWrapperComponent.prototype, "labels", void 0);
TuiDataListGroupWrapperComponent = TuiDataListGroupWrapperComponent_1 = __decorate([ __param(0, Inject(TUI_ITEMS_HANDLERS))
], TuiDataListGroupWrapperComponent);

var TuiDataListWrapperComponent_1;
let TuiDataListWrapperComponent = TuiDataListWrapperComponent_1 = class TuiDataListWrapperComponent extends AbstractDataListWrapper {
    constructor(itemsHandlers) {
        super(itemsHandlers);
        this.items = [];
    }
};
TuiDataListWrapperComponent.ɵfac = function TuiDataListWrapperComponent_Factory(t) { return new (t || TuiDataListWrapperComponent)(ɵngcc0.ɵɵdirectiveInject(TUI_ITEMS_HANDLERS)); };
TuiDataListWrapperComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TuiDataListWrapperComponent, selectors: [["tui-data-list-wrapper", 3, "labels", ""]], inputs: { items: "items" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TUI_DATA_LIST_ACCESSOR$1,
                useExisting: forwardRef(() => TuiDataListWrapperComponent_1)
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 2, consts: [[3, "emptyContent", 4, "ngIf", "ngIfElse"], ["loading", ""], [3, "emptyContent"], ["tuiElement", "", "tuiOption", "", "automation-id", "tui-data-list-wrapper__option", 3, "size", "value", "disabled", 4, "ngFor", "ngForOf"], ["tuiElement", "", "tuiOption", "", "automation-id", "tui-data-list-wrapper__option", 3, "size", "value", "disabled"], ["elementRef", "elementRef"], ["polymorpheus-outlet", "", 1, "t-content", 3, "content", "context"], ["automation-id", "tui-data-list-wrapper__loader", 1, "t-loader"]], template: function TuiDataListWrapperComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TuiDataListWrapperComponent_tui_data_list_0_Template, 2, 2, "tui-data-list", 0);
        ɵngcc0.ɵɵtemplate(1, TuiDataListWrapperComponent_ng_template_1_Template, 1, 0, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.items)("ngIfElse", _r1);
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.TuiDataListComponent, ɵngcc1.NgForOf, ɵngcc2.TuiOptionComponent, ɵngcc3.TuiElementDirective, ɵngcc4.PolymorpheusOutletComponent, ɵngcc2.TuiLoaderComponent], styles: [_c1], changeDetection: 0 });
TuiDataListWrapperComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [TUI_ITEMS_HANDLERS,] }] }
];
__decorate([
    Input(),
    tuiDefaultProp()
], TuiDataListWrapperComponent.prototype, "items", void 0);
TuiDataListWrapperComponent = TuiDataListWrapperComponent_1 = __decorate([ __param(0, Inject(TUI_ITEMS_HANDLERS))
], TuiDataListWrapperComponent);

let TuiDataListWrapperModule = class TuiDataListWrapperModule {
};
TuiDataListWrapperModule.ɵfac = function TuiDataListWrapperModule_Factory(t) { return new (t || TuiDataListWrapperModule)(); };
TuiDataListWrapperModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiDataListWrapperModule });
TuiDataListWrapperModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            PolymorpheusModule,
            TuiElementModule,
            TuiDataListModule,
            TuiLoaderModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AbstractDataListWrapper, [{
        type: Directive
    }], function () { return [{ type: undefined }]; }, { optionsQuery: [{
            type: ViewChildren,
            args: [forwardRef(() => TuiOptionComponent)]
        }], disabledItemHandler: [{
            type: Input
        }], emptyContent: [{
            type: Input
        }], size: [{
            type: Input
        }], itemContent: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiDataListGroupWrapperComponent, [{
        type: Component,
        args: [{
                selector: 'tui-data-list-wrapper[labels]',
                template: "<tui-data-list\n    *ngIf=\"items; else loading\"\n    [emptyContent]=\"emptyContent\"\n>\n    <tui-opt-group\n        *ngFor=\"let group of items; let index = index\"\n        [label]=\"labels[index]\"\n    >\n        <button\n            *ngFor=\"let item of group\"\n            #elementRef=\"elementRef\"\n            tuiElement\n            tuiOption\n            automation-id=\"tui-data-list-wrapper__option\"\n            [size]=\"size\"\n            [value]=\"item\"\n            [disabled]=\"disabledItemHandler(item)\"\n        >\n            <span\n                polymorpheus-outlet\n                class=\"t-content\"\n                [content]=\"itemContent\"\n                [context]=\"getContext(item, elementRef)\"\n            ></span>\n        </button>\n    </tui-opt-group>\n</tui-data-list>\n<ng-template #loading>\n    <tui-loader class=\"t-loader\"></tui-loader>\n</ng-template>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    {
                        provide: TUI_DATA_LIST_ACCESSOR,
                        useExisting: forwardRef(() => TuiDataListGroupWrapperComponent_1)
                    },
                ],
                styles: [":host{display:block}.t-content{flex:1}.t-loader{margin:.75rem 0}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [TUI_ITEMS_HANDLERS]
            }] }]; }, { items: [{
            type: Input
        }], labels: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiDataListWrapperComponent, [{
        type: Component,
        args: [{
                selector: 'tui-data-list-wrapper:not([labels])',
                template: "<tui-data-list\n    *ngIf=\"items; else loading\"\n    [emptyContent]=\"emptyContent\"\n>\n    <button\n        *ngFor=\"let item of items\"\n        #elementRef=\"elementRef\"\n        tuiElement\n        tuiOption\n        automation-id=\"tui-data-list-wrapper__option\"\n        [size]=\"size\"\n        [value]=\"item\"\n        [disabled]=\"disabledItemHandler(item)\"\n    >\n        <span\n            polymorpheus-outlet\n            class=\"t-content\"\n            [content]=\"itemContent\"\n            [context]=\"getContext(item, elementRef)\"\n        ></span>\n    </button>\n</tui-data-list>\n<ng-template #loading>\n    <tui-loader\n        automation-id=\"tui-data-list-wrapper__loader\"\n        class=\"t-loader\"\n    ></tui-loader>\n</ng-template>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    {
                        provide: TUI_DATA_LIST_ACCESSOR$1,
                        useExisting: forwardRef(() => TuiDataListWrapperComponent_1)
                    },
                ],
                styles: [":host{display:block}.t-content{flex:1}.t-loader{margin:.75rem 0}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [TUI_ITEMS_HANDLERS]
            }] }]; }, { items: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiDataListWrapperModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    PolymorpheusModule,
                    TuiElementModule,
                    TuiDataListModule,
                    TuiLoaderModule,
                ],
                declarations: [TuiDataListWrapperComponent, TuiDataListGroupWrapperComponent],
                exports: [
                    TuiDataListWrapperComponent,
                    TuiDataListGroupWrapperComponent,
                    TuiDataListDirective,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiDataListWrapperModule, { declarations: function () { return [TuiDataListWrapperComponent, TuiDataListGroupWrapperComponent]; }, imports: function () { return [CommonModule,
        PolymorpheusModule,
        TuiElementModule,
        TuiDataListModule,
        TuiLoaderModule]; }, exports: function () { return [TuiDataListWrapperComponent, TuiDataListGroupWrapperComponent, TuiDataListDirective]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { AbstractDataListWrapper, TuiDataListGroupWrapperComponent, TuiDataListWrapperComponent, TuiDataListWrapperModule };

